export default __webpack_public_path__ + "static/media/tunnel-lit.82c201bd.jpg";